import { isArray, isEmpty } from 'lodash';
import { IAsset } from 'src/interfaces';

import { ResourceType } from './resourceSelectorSidebarWidget/ResourceSelectorSidebar.interface';

const isImage = (fileName: string) => {
  const ext = fileName.split('.').pop();
  if (ext === 'png' || ext === 'jpeg' || ext === 'jpg' || ext === 'gif') {
    return true;
  } else {
    return false;
  }
};

export const filterAssetsBySearchName = (
  assets: IAsset[],
  searchVal: string | string[],
  type: ResourceType,
) => {
  if (isEmpty(assets)) return assets;

  if (type === ResourceType.PRODUCT) {
    const productAssets = assets.filter((asset) => {
      const fileName = asset.fileName.toLowerCase();

      return isImage(fileName);
    });

    if (isArray(searchVal)) {
      return productAssets.filter((asset) => {
        const fileName = asset.fileName.toLowerCase();

        return (
          isImage(fileName) &&
          searchVal.find((value) => fileName.includes(value.toLowerCase()))
        );
      });
    }

    return productAssets.filter((asset) =>
      asset.fileName.toLowerCase().includes(searchVal.toLowerCase()),
    );
  }

  if (isArray(searchVal)) {
    return assets.filter((asset) => {
      const fileName = asset.fileName.toLowerCase();

      return searchVal.find((value) => fileName.includes(value.toLowerCase()));
    });
  }

  return assets.filter((asset) =>
    asset.fileName.toLowerCase().includes(searchVal.toLowerCase()),
  );
};

export const findMatchedAsset = (
  assetList: IAsset[],
  assetId?: string,
  fileName?: string,
) => {
  return assetList.find(
    (asset) => asset.assetId === assetId || asset.fileName === fileName,
  );
};

export function checkAssetMatch(
  selectedAssets: IAsset[] = [],
  asset: IAsset,
  defaultAsset?: IAsset,
) {
  return (
    !!findMatchedAsset(selectedAssets, asset.assetId) ||
    defaultAsset?.assetId === asset.assetId
  );
}
